import { PRINT_TAG_LIST_TYPE } from '../types'

const state = {
  listType: 'batches'
}

const mutations = {
  [PRINT_TAG_LIST_TYPE] (state, value) {
    state.listType = value
  }
}

const getters = {
  printTagListType: state => {
    return state.listType
  }
}

const actions = {
  setPrintTagListType: function ({ commit }, value) {
    commit(PRINT_TAG_LIST_TYPE, value)
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
